
export default function CustomerReviews() {
  const reviews = [
    {
      name: 'Carlos M.',
      vehicle: 'Mercedes-Benz S-Class',
      rating: 5,
      text: 'Absolutely incredible service! They came to my office and detailed my S-Class while I was in meetings. The car looked brand new when I came out. The interior smelled amazing and every surface was spotless. Worth every penny!',
      date: '2 weeks ago'
    },
    {
      name: 'Jennifer R.',
      vehicle: 'Tesla Model X',
      rating: 5,
      // Use double quotes (or escaped single quotes) to avoid breaking the string literal
      text: "I've tried several detailing services in Miami, but Miami Line Lux is on another level. They're professional, punctual, and the attention to detail is unmatched. My white leather seats look like they just came from the factory.",
      date: '1 month ago'
    },
    {
      name: 'Michael T.',
      vehicle: 'Porsche 911',
      rating: 5,
      text: 'These guys know what they\'re doing. I\'m very particular about my Porsche, and they treated it with the care it deserves. The paint protection they applied is holding up great, and the interior detailing was flawless. Highly recommend!',
      date: '3 weeks ago'
    },
    {
      name: 'Sofia L.',
      vehicle: 'Range Rover Sport',
      rating: 5,
      text: 'Best mobile detailing in Miami! They came to my house in Coral Gables and spent hours making sure everything was perfect. My kids had destroyed the back seats, but you\'d never know it now. Amazing transformation!',
      date: '1 week ago'
    }
  ];

  return (
    <section className="py-20 bg-gradient-to-b from-black via-gray-900 to-black relative overflow-hidden">
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0 bg-gradient-to-br from-yellow-500/20 to-transparent"></div>
      </div>

      <div className="max-w-7xl mx-auto px-6 relative z-10">
        {/* Section Header */}
        <div className="text-center mb-16">
          <p className="text-yellow-500 uppercase tracking-wider text-sm font-semibold mb-3">
            TESTIMONIALS
          </p>
          <h2 className="text-4xl md:text-6xl font-bold text-white mb-6">
            What Our Customers Say
          </h2>
          <div className="flex items-center justify-center gap-2 mb-4">
            <div className="flex gap-1">
              {[...Array(5)].map((_, i) => (
                <i key={i} className="ri-star-fill text-yellow-500 text-2xl"></i>
              ))}
            </div>
            <span className="text-gray-300 text-lg font-semibold">5.0 Average Rating</span>
          </div>
          <p className="text-gray-400">Based on real customer experiences</p>
        </div>

        {/* Reviews Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12">
          {reviews.map((review, index) => (
            <div
              key={index}
              className="bg-gradient-to-br from-gray-900 to-black border border-yellow-500/20 rounded-2xl p-8 hover:border-yellow-500/40 transition-all duration-300"
            >
              {/* Stars */}
              <div className="flex gap-1 mb-4">
                {[...Array(review.rating)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-yellow-500 text-xl"></i>
                ))}
              </div>

              {/* Review Text */}
              <p className="text-gray-300 leading-relaxed mb-6 text-lg">
                "{review.text}"
              </p>

              {/* Customer Info */}
              <div className="flex items-center justify-between pt-6 border-t border-gray-800">
                <div>
                  <p className="text-white font-bold">{review.name}</p>
                  <p className="text-gray-500 text-sm">{review.vehicle}</p>
                </div>
                <p className="text-gray-600 text-sm">{review.date}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Trusted with Luxury Vehicles Section */}
        <div className="bg-gradient-to-br from-gray-900 to-black border-2 border-yellow-500/40 rounded-2xl overflow-hidden">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-0">
            {/* Image */}
            <div className="relative h-80 lg:h-auto">
              <img
                src="https://public.readdy.ai/ai/img_res/e0ebc316e08999a671013a160b3a7f05.jpg"
                alt="Trusted with luxury vehicles - Rolls-Royce"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-r from-black/60 to-transparent lg:hidden"></div>
            </div>

            {/* Content */}
            <div className="p-8 lg:p-12 flex flex-col justify-center">
              <div className="inline-flex items-center gap-2 bg-yellow-500/20 border border-yellow-500/40 rounded-full px-4 py-2 mb-6 w-fit">
                <i className="ri-vip-crown-fill text-yellow-500"></i>
                <span className="text-yellow-500 font-semibold text-sm">Trusted by Luxury Car Owners</span>
              </div>

              <h3 className="text-3xl md:text-4xl font-bold text-white mb-4">
                Your Vehicle is in Expert Hands
              </h3>
              <p className="text-gray-300 leading-relaxed mb-6 text-lg">
                From everyday vehicles to high-end luxury cars, we treat every vehicle with the same level of care and professionalism. Our clients trust us with their most valuable assets, and we never take that responsibility lightly.
              </p>

              <div className="space-y-3 mb-8">
                <div className="flex items-center gap-3">
                  <i className="ri-shield-check-fill text-yellow-500 text-xl"></i>
                  <span className="text-white font-semibold">Fully insured and professional</span>
                </div>
                <div className="flex items-center gap-3">
                  <i className="ri-star-fill text-yellow-500 text-xl"></i>
                  <span className="text-white font-semibold">Premium products only</span>
                </div>
                <div className="flex items-center gap-3">
                  <i className="ri-user-star-fill text-yellow-500 text-xl"></i>
                  <span className="text-white font-semibold">Experienced detailing specialists</span>
                </div>
              </div>

              <a
                href="sms:+17863272644"
                className="bg-yellow-500 text-black px-8 py-4 rounded-full font-bold hover:bg-yellow-400 transition-all inline-flex items-center justify-center gap-2 whitespace-nowrap cursor-pointer shadow-xl shadow-yellow-500/40 w-fit"
              >
                <i className="ri-message-3-line text-xl"></i>
                Book Your Detail Now
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
